"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var description_1 = require("./utils/description");
/**
 * Checks whether a value is a Date object
 *
 * @example
 * is.date(new Date()); true
 * is.date(1415402574000); // false
 */
function isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
}
exports.default = isDate;
description_1.setDescription(isDate, 'a Date');
